// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"129":"eb00b008","587":"98c67ed2","822":"a168ce67"}[chunkId] + ".chunk.js";
};